const SRC = [
  { key: "mine", label: "Only mine" },
  { key: "shared", label: "Shared with me" },
  { key: "public", label: "Public" },
  { key: "historical", label: "Historical" },
];
const TIMES = [15, 30, 45, 60];

const chip = (on) =>
  `px-3 py-1.5 rounded-full text-xs font-bold border transition-colors ${on ? "bg-rf-orange text-white border-rf-orange" : "bg-white text-rf-ink-soft border-rf-ink/15 hover:border-rf-ink/40"}`;

export const SearchFilterChips = ({ filters, onChange, signedIn }) => {
  const active = filters.src || filters.max || filters.easy;
  return (
    <div className="flex flex-wrap items-center gap-1.5 mb-6" data-testid="search-voice-filters">
      <span className="text-[11px] uppercase tracking-wider font-bold text-rf-ink-soft mr-1">Narrow:</span>
      {SRC.filter((s) => signedIn || s.key === "public" || s.key === "historical").map((s) => (
        <button key={s.key} type="button" data-testid={`search-src-${s.key}`} className={chip(filters.src === s.key)}
          onClick={() => onChange({ ...filters, src: filters.src === s.key ? null : s.key })}>{s.label}</button>
      ))}
      {TIMES.map((m) => (
        <button key={m} type="button" data-testid={`search-max-${m}`} className={chip(filters.max === m)}
          onClick={() => onChange({ ...filters, max: filters.max === m ? null : m })}>≤ {m} min</button>
      ))}
      {filters.max && !TIMES.includes(filters.max) && (
        <button type="button" data-testid="search-max-custom" className={chip(true)} onClick={() => onChange({ ...filters, max: null })}>≤ {filters.max} min</button>
      )}
      <button type="button" data-testid="search-easy" className={chip(!!filters.easy)}
        onClick={() => onChange({ ...filters, easy: !filters.easy })}>Easy</button>
      {active && (
        <button type="button" data-testid="search-filters-clear" onClick={() => onChange({})}
          className="text-xs font-bold text-rf-ink-soft underline ml-1 hover:text-rf-ink">Clear</button>
      )}
    </div>
  );
};
